import FormDataHandler from '../functions/FormDataHandler'

export const testTokenizerSubmit = (formData, setFormError, setFormStatus) => {
  const dataHandler = new FormDataHandler()
  const testFormData = {
    '2': {
      creditCardType: 'MasterCard',
      creditCardNumber: '4111111111111111',
      creditCardExpiration: '09/24',
    },
  }

  dataHandler.tokenizeCreditCard(testFormData, response => {
    if (!response.success) {
      setFormError(response.data.error)
      return
    }

    setFormStatus('complete')
  })
}
